import './fonts.css';
import './i18n';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

import { createRoot } from 'react-dom/client';
import App from './App';
import DataLayer from './utils/dataLayer/DataLayer';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import StateProvider from './StateProvider';

window.addEventListener(
  'error',
  (e: ErrorEvent | Event) => {
    const target = e?.target;

    if (
      target instanceof HTMLScriptElement &&
      target.src.includes('/static/js/')
    ) {
      console.warn('JS chunk load failed. Forcing reload.');
      window.location.reload();
    }

    if (
      target instanceof HTMLLinkElement &&
      target.href.includes('/static/css/')
    ) {
      console.warn('CSS chunk load failed. Forcing reload.');
      window.location.reload();
    }

    if (
      (e as ErrorEvent)?.message?.includes('Loading chunk') ||
      (e as ErrorEvent)?.message?.includes('Loading CSS chunk')
    ) {
      console.warn('Chunk error (from message). Reloading.');
      window.location.reload();
    }
  },
  true,
); // capture=true to catch non-bubbling load errors

const container = document.getElementById('root');

container &&
  createRoot(container).render(
    <React.StrictMode>
      <BrowserRouter>
        <StateProvider>
          <DataLayer />
          <App />
        </StateProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an customAnalytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
